import React, { Component, Fragment } from 'react'
import { Link } from 'react-router-dom'
import { List, ListItem, ListItemText, ListItemIcon, Collapse, ListItemSecondaryAction, IconButton } from '@material-ui/core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
    faChevronDown,
    faChevronRight
} from "@fortawesome/free-solid-svg-icons"

import "./sidebarMenu.css";

class SidebarMenu extends Component {

    constructor(props) {
        super(props);
        this.state = { open: true };
    }


    handleOpen = () => {
        this.setState({
            open: !this.state.open
        });
    };

    renderSubMenu = (subMenu, menukey) => {
        return subMenu.filter(x => (x !== undefined || x !== null) && x).map((menu, index) => {
            return (
                <ListItem
                    key={index}
                    button
                    dense={true}
                    className={menu.key === menukey ? 'stm-sidebar-selected' : 'stm-sidebar-default'}
                    classes={{ divider: "sidebar-divider" }}
                    style=
                    {{
                        paddingLeft: "56px",
                        background: `${menu.key === menukey ? '#032141' : 'unset'}`
                    }}
                    component={Link}
                    to={menu.link}
                >
                    <ListItemIcon
                        classes={
                            {
                                root: "list-item-icon"
                            }
                        }
                    >
                        <FontAwesomeIcon icon={menu.icon} style={{ color: '#fff' }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={menu.label}
                        classes={
                            {
                                root: "list-item-label"
                            }
                        }
                    />
                </ListItem>
            );
        });
    }

    render() {
        const { open } = this.state;
        const { label, redirectUrl, icon, subMenu, menukey } = this.props;
        return (
            <Fragment>
                <ListItem
                    button
                    dense
                    onClick={subMenu ? this.handleOpen : undefined}
                    component={subMenu ? "li" : Link}
                    to={subMenu ? undefined : redirectUrl}
                    target="_self"
                    classes={
                        {
                            root: "list-item"
                        }
                    }
                >
                    <ListItemIcon
                        classes={
                            {
                                root: "list-item-icon"
                            }
                        }
                    >
                        <FontAwesomeIcon icon={icon} style={{ color: '#fff' }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={label}
                        classes={
                            {
                                root: "list-item-label"
                            }
                        }
                    />
                    {
                        subMenu ? (
                            <ListItemSecondaryAction>
                                <IconButton size="small" onClick={this.handleOpen} >
                                    <FontAwesomeIcon icon={open ? faChevronDown : faChevronRight} style={{ color: '#fff', fontSize: 12 }} />
                                </IconButton>
                            </ListItemSecondaryAction>
                        ) : null
                    }
                </ListItem>
                {
                    subMenu ? (
                        <Collapse in={this.state.open} timeout="auto" unmountOnExit>
                            <List component="div" disablePadding>
                                {this.renderSubMenu(subMenu, menukey)}
                            </List>
                        </Collapse>
                    ) : null
                }
            </Fragment>

        );
    }
}

export default SidebarMenu;